import { useDispatch, useSelector } from "react-redux";
import { setFiltersFeedSortBy } from "web/redux/ducks/filters";
import { ReduxStoreState } from "web/redux/store";
import { gettext } from "web/script/modules/django-i18n";
import environment from "web/script/modules/environment";

export interface UseFiltersSortByResult {
    sortBy: string;

    onChange(sortBy: string): void;

    items: SortOption[];
}

interface SortOption {
    value: string;
    label: string;
    analyticsLabel: string;
}

export const items = [
    {
        value: "recommended",
        label: gettext("feed.filters.recommended"),
        analyticsLabel: "SORT_BY_RECOMMENDED",
    },
    {
        value: "newest",
        label: gettext("feed.filters.newest"),
        analyticsLabel: "SORT_BY_NEWEST",
    },
    {
        value: "price_asc",
        label: gettext("feed.filters.price_low_high"),
        analyticsLabel: "SORT_BY_LOW_HIGH",
    },
    {
        value: "price_desc",
        label: gettext("feed.filters.price_high_low"),
        analyticsLabel: "SORT_BY_HIGH_LOW",
    },
];

export function useSortBy(): UseFiltersSortByResult {
    const dispatch = useDispatch();
    const { sortBy } = useSelector((state: ReduxStoreState) => state.filters.ui);
    const feedType = environment.get("feedType");
    const discount = {
        value: "discount_desc",
        label: gettext("feed.filters.discount_high_low"),
        analyticsLabel: "SORT_BY_DISCOUNT_HIGH_LOW",
    };
    if (
        feedType === "SALE_TAXONOMY_FEED" &&
        !items.some((item) => item.value === "discount_desc") &&
        environment.getFeature("uf_enable_redesign_mobile_filter") &&
        environment.getFeature("uf_enable_sortbydiscount")
    ) {
        items.push(discount);
    }

    function onChange(sortBy: string): void {
        // Set checked item
        dispatch(setFiltersFeedSortBy(sortBy));
    }

    return {
        sortBy,
        onChange,
        items,
    };
}
